var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.99,
    height: 93.601,
    viewBox: "0 0 85.99 93.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#a4afc1}.cls-3{fill:#f3f3f1}.cls-4{fill:#54b8a9}.cls-5{fill:#279c8b}.cls-6{fill:#d5dbe1}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subject",
    transform: "translate(-2 -.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    transform: "translate(2.779 .584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    fill: "#efefef",
    d: "M70.365 10.212c-18.588 0-31.352-9.628-40.308-9.628S2.29 5.733 2.29 46.935s25.31 47.25 35.157 47.25c46.131.002 65.836-83.973 32.918-83.973z",
    transform: "translate(-2.29 -.584)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    transform: "translate(22.49 7.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    d: "M9.625 3.25h2.687v5.374H9.625z",
    className: "cls-2",
    transform: "translate(-9.625 -3.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    transform: "translate(13.085 15.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    d: "M6.125 6.25H11.5v2.687H6.125z",
    className: "cls-2",
    transform: "translate(-6.125 -6.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    transform: "translate(28.536 15.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    d: "M11.875 6.25h5.374v2.687h-5.374z",
    className: "cls-2",
    transform: "translate(-11.875 -6.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    transform: "translate(33.575 27.902)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 11.421,
    cy: 11.421,
    r: 11.421,
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    transform: "translate(53.729 17.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    d: "M27.968 20.186H21.25v-6.718l6.718-6.718v6.718h6.718z",
    className: "cls-3",
    transform: "translate(-21.25 -6.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    transform: "translate(14.764 28.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    d: "M64.525 11H54.448l-2.015 2.015h-6.719V11H40.7a11.421 11.421 0 1 1-7.438 0H9.437a2.688 2.688 0 0 0-2.687 2.687v28.888h60.462V13.687A2.688 2.688 0 0 0 64.525 11z",
    className: "cls-4",
    transform: "translate(-6.75 -11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    transform: "translate(36.262 69.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    d: "M28.186 26.25a15.777 15.777 0 0 0 3.977 8.062H14.75a15.54 15.54 0 0 0 3.977-8.062z",
    className: "cls-4",
    transform: "translate(-14.75 -26.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    transform: "translate(14.764 60.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    d: "M64.525 32.155H9.437a2.688 2.688 0 0 1-2.687-2.687V22.75h60.462v6.718a2.688 2.688 0 0 1-2.687 2.687z",
    className: "cls-3",
    transform: "translate(-6.75 -22.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    transform: "translate(14.764 28.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    d: "M15.483 11H9.437a2.688 2.688 0 0 0-2.687 2.687v28.888h6.05V13.687A2.688 2.688 0 0 1 15.483 11z",
    className: "cls-5",
    transform: "translate(-6.75 -11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    transform: "translate(36.262 69.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    d: "M18.727 26.25a15.54 15.54 0 0 1-3.977 8.062h6.05a15.54 15.54 0 0 0 3.977-8.062z",
    className: "cls-5",
    transform: "translate(-14.75 -26.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    transform: "translate(33.575 27.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    d: "M19.46 22.171a11.4 11.4 0 0 1 8.567-11.018 11.422 11.422 0 1 0 0 22.035 11.4 11.4 0 0 1-8.567-11.017z",
    className: "cls-6",
    transform: "translate(-13.75 -10.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    transform: "translate(53.729 17.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    d: "M27.968 12.46V6.75l-6.718 6.718v6.718h5.71v-6.718z",
    className: "cls-6",
    transform: "translate(-21.25 -6.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    transform: "translate(14.764 60.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    d: "M12.46 29.468V22.75H6.75v6.718a2.688 2.688 0 0 0 2.687 2.687h5.71a2.688 2.688 0 0 1-2.687-2.687z",
    className: "cls-6",
    transform: "translate(-6.75 -22.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    transform: "translate(31.559 25.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    d: "M26.436 36.872a13.436 13.436 0 1 1 0-26.872v4.031a9.405 9.405 0 1 0 9.405 9.405h4.031a13.451 13.451 0 0 1-13.436 13.436z",
    transform: "translate(-13 -10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    transform: "translate(43.561 29.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    d: "M0 0h11.4v4.031H0z",
    transform: "rotate(-45 9.73 4.03)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    transform: "translate(51.713 15.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    d: "M29.233 23.467h-6.718a2.016 2.016 0 0 1-2.015-2.016v-6.718a2.007 2.007 0 0 1 .591-1.424l6.718-6.718a2.014 2.014 0 0 1 3.44 1.424v4.7h4.7a2.014 2.014 0 0 1 1.424 3.44l-6.718 6.718a2.007 2.007 0 0 1-1.424.591zm-4.7-4.031H28.4l2.687-2.687h-1.854a2.016 2.016 0 0 1-2.015-2.015v-1.852l-2.687 2.687z",
    transform: "translate(-20.5 -6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    transform: "translate(12.749 25.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    d: "M65.79 55.682H10.7A4.708 4.708 0 0 1 6 50.98V14.7a4.708 4.708 0 0 1 4.7-4.7h11.423v4.031H10.7a.672.672 0 0 0-.672.672V50.98a.672.672 0 0 0 .672.672h55.09a.672.672 0 0 0 .672-.672V14.7a.672.672 0 0 0-.672-.672h-2.015V10h2.015a4.708 4.708 0 0 1 4.7 4.7v36.28a4.708 4.708 0 0 1-4.7 4.702z",
    transform: "translate(-6 -10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    transform: "translate(14.764 58.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    d: "M6.75 22h60.462v4.031H6.75z",
    transform: "translate(-6.75 -22)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1210",
    transform: "translate(34.246 69.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    d: "M33.482 36.5H16.016a2.014 2.014 0 0 1-1.424-3.44 13.672 13.672 0 0 0 3.4-6.9l4 .524a18.071 18.071 0 0 1-2 5.783h9.468a18.51 18.51 0 0 1-2-5.769l3.99-.559a13.989 13.989 0 0 0 3.182 6.688 2.013 2.013 0 0 1-1.15 3.673z",
    transform: "translate(-14 -26.145)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    transform: "translate(2 75.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    d: "M2 28.5h85.99v4.031H2z",
    transform: "translate(-2 -28.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpose);
export default __webpack_public_path__ + "static/media/PURPOSE.641811511865adcf6b60e5c9b00971de.svg";
export { ForwardRef as ReactComponent };